import React, { useState, useEffect } from 'react'
import { Modal, Spinner } from 'react-bootstrap'
import { useWalletProviderContext } from 'wallet-module/provider/WalletProvider'
import { closeIcon } from '../assets/images'
import ErrorMsgModal from './ErrorMsgModal'
import MetaMask from './MetaMask'
import { useAccount, useConnect, useDisconnect } from 'wagmi'
import WalletConnect from './WalletConnect'
import Coinbase from './Coinbase'
import '../assets/styles/styles.scss'
import { getParsedMessage } from 'wallet-module/utils/utils'

const ModalETHWallets = (): JSX.Element => {
  const [errorMessage, setErrorMessage] = useState<string | null>(null)
  const { showETHConnectionModal, setShowETHConnectionModal, supportedChainID } =
    useWalletProviderContext()
  const [isConnectingToWallet, setIsConnectingToWallet] = useState(false)
  const { disconnect } = useDisconnect()
  const { address, isConnecting } = useAccount()
  const { connect, connectors, data, error } = useConnect()

  useEffect(() => {
    if (error !== undefined && error !== null) {
      // console.log('Test data:', JSON.stringify(error ?? {}))
      disconnect()
      const message = getParsedMessage(error)
      setErrorMessage(message)

      return
    }

    if (data !== undefined && data.chain !== undefined) {
      if (data.chain.unsupported == true || data.chain.id !== supportedChainID) {
        disconnect()
        setErrorMessage(
          `It seems you are using the wrong network to connect. Please shift to ${
            supportedChainID == 1 ? 'Ethereum Mainnet.' : 'Testnet.'
          }`
        )
        return
      }
      if (data?.account !== undefined) {
        setShowETHConnectionModal(false)
      }
      return
    }
  }, [data, error?.message])
  useEffect(() => {
    // if (address !== null) {
    //   setShowETHConnectionModal(false)
    // }
  }, [address])
  useEffect(() => {
    setIsConnectingToWallet(isConnecting)
  }, [isConnecting])
  const resetWallets = (): void => {}
  // useEffect(() => {s

  //   if (
  //     error?.name === 'UnsupportedChainIdError' ||
  //     error?.message?.includes('Unsupported chain') === true
  //   ) {
  //     setErrorMessage(
  //       'It seems you are using the wrong network to connect. Please shift to Ethereum Mainnet'
  //     )
  //     resetWallets()
  //   } else if (error?.message?.includes('eth_requestAccounts') === true) {
  //     setErrorMessage('Please sign in to your wallet provider.')
  //     resetWallets()
  //   } else if (error !== undefined && error !== null) {
  //     setErrorMessage(error.message)
  //     resetWallets()
  //   }
  //   // if (error && error != null) {
  //   //   setProvider(null)
  //   //   setError(null)
  //   // }
  // }, [error])

  const handleMetaMaskClick = () => {
    connect({ connector: connectors[0], chainId: supportedChainID })
  }
  const handleWalletConnectClick = () => {
    connect({ connector: connectors[1], chainId: supportedChainID })
  }
  const handleCoinBaseClick = () => {
    connect({ connector: connectors[2], chainId: supportedChainID })
  }
  const handleCloseModal = () => {
    setErrorMessage(null)
    setShowETHConnectionModal(false)
    setIsConnectingToWallet(false)
  }
  return (
    <>
      {showETHConnectionModal && (
        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          dialogClassName="w-580"
          contentClassName="wallet-selection-modal"
          show
          centered>
          <div className="inner-content text-center">
            {errorMessage === null && (
              <>
                <div className="modal-title text-center">
                  <h3 className="title md text-capitalize mb-5">Connect Your Wallet</h3>
                  <p className="mb-0">Please ensure you attach the ETH Wallet that is connected to your Virtua account.</p>
                </div>
                <div>
                  {isConnectingToWallet && (
                    <Spinner animation="border" className="position-absolute mt-5" />
                  )}
                  <div className={`pt-0 pb-0 ${isConnectingToWallet && 'invisible'}`}>
                    <div className="wallet-modal-inner">
                      <MetaMask handleMetaMaskClick={handleMetaMaskClick} />
                    </div>
                    <div className="wallet-modal-inner">
                      <WalletConnect handleWalletConnectClick={handleWalletConnectClick} />
                    </div>
                    <div className="wallet-modal-inner">
                      <Coinbase handleCoinBaseClick={handleCoinBaseClick} />
                    </div>
                  </div>
                </div>
              </>
            )}
            {errorMessage !== null && <ErrorMsgModal errorMessage={errorMessage} />}
            <img
              src={closeIcon}
              alt="crossIcon"
              className="close-connect-modal"
              onClick={() => {
                handleCloseModal()
              }}
            />
          </div>
        </Modal>
      )}
    </>
  )
}

export default ModalETHWallets
